export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<g clip-path="url(#clip0_144_5595)">
			<path
				d="M8.0625 6.875V9.5H15.9375V6.875C15.9375 4.70117 14.1738 2.9375 12 2.9375C9.82617 2.9375 8.0625 4.70117 8.0625 6.875ZM6.75 9.5V6.875C6.75 4.00391 9.08789 1.625 12 1.625C14.8711 1.625 17.25 4.00391 17.25 6.875V9.5H17.9062C19.7109 9.5 21.1875 10.9766 21.1875 12.7812V19.3438C21.1875 21.1895 19.7109 22.625 17.9062 22.625H6.09375C4.24805 22.625 2.8125 21.1895 2.8125 19.3438V12.7812C2.8125 10.9766 4.24805 9.5 6.09375 9.5H6.75ZM4.125 12.7812V19.3438C4.125 20.4512 4.98633 21.3125 6.09375 21.3125H17.9062C18.9727 21.3125 19.875 20.4512 19.875 19.3438V12.7812C19.875 11.7148 18.9727 10.8125 17.9062 10.8125H6.09375C4.98633 10.8125 4.125 11.7148 4.125 12.7812Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_144_5595">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
